"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _exportWarehouse = require("@/api/export-warehouse");
var _product = require("@/api/product");
var _staff = require("@/api/staff");
var _enum = require("@/utils/enum");
var _vuePropertyDecorator = require("vue-property-decorator");
var _AddProductOrderModal = _interopRequireDefault(require("./AddProductOrderModal.vue"));
var ProductOrderForm = /*#__PURE__*/function (_Vue) {
  function ProductOrderForm() {
    var _this;
    (0, _classCallCheck2.default)(this, ProductOrderForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ProductOrderForm, [].concat(args));
    (0, _defineProperty2.default)(_this, "form", void 0);
    (0, _defineProperty2.default)(_this, "statusForm", void 0);
    (0, _defineProperty2.default)(_this, "orderStatus", void 0);
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "productId", null);
    (0, _defineProperty2.default)(_this, "staffs", []);
    (0, _defineProperty2.default)(_this, "products", []);
    (0, _defineProperty2.default)(_this, "rules", {
      staffId: {
        required: true,
        message: "Field is required!",
        trigger: "submit"
      },
      date: {
        required: true,
        message: "Field is required!",
        trigger: "submit"
      }
    });
    (0, _defineProperty2.default)(_this, "summary", {
      totalPrice: 0,
      profit: 0,
      vatPrice: 0,
      afterVatPrice: 0
    });
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "ExportWarehouseType", _enum.ExportWarehouseType);
    return _this;
  }
  (0, _inherits2.default)(ProductOrderForm, _Vue);
  return (0, _createClass2.default)(ProductOrderForm, [{
    key: "created",
    value: function created() {
      // this.fetchProduct();
      this.fetchStaffs();
    }
  }, {
    key: "fetchStaffs",
    value: function fetchStaffs() {
      var _this2 = this;
      _staff.staffApi.findAll().then(function (res) {
        return _this2.staffs = res.data.data;
      });
    }
  }, {
    key: "handleAddProduct",
    value: function handleAddProduct() {
      this.$refs.productModal.handleCreate();
    }
  }, {
    key: "watchFormProducts",
    value: function watchFormProducts(data) {
      data.forEach(function (element) {
        element.remainQuantity = element.quantity - element.exportQuantity;
      });
    }
  }, {
    key: "handleChangeProduct",
    value: function handleChangeProduct(product) {
      if (this.form.products.some(function (e) {
        return e.id == product.id;
      })) {
        return this.$message.error("This product is exist!");
      }
      if (product) {
        this.form.products.push((0, _objectSpread2.default)((0, _objectSpread2.default)({}, product), {}, {
          exportQuantity: 1
        }));
      }
    }
  }, {
    key: "handleRemoveProd",
    value: function () {
      var _handleRemoveProd = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(index, item) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.statusForm == "update" && item.detailId)) {
                _context.next = 9;
                break;
              }
              _context.next = 3;
              return this.$confirm("Confirm delete product", "Warning", {
                cancelButtonText: "No",
                confirmButtonText: "Delete",
                type: "warning"
              });
            case 3:
              this.form.products.splice(index, 1);
              _context.next = 6;
              return _exportWarehouse.exportWarehouseApi.deleteDetail(item.detailId);
            case 6:
              this.$notify({
                title: "Delete product",
                message: "Successfully",
                type: "success"
              });
              _context.next = 10;
              break;
            case 9:
              this.form.products.splice(index, 1);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleRemoveProd(_x, _x2) {
        return _handleRemoveProd.apply(this, arguments);
      }
      return handleRemoveProd;
    }()
  }, {
    key: "fetchProduct",
    value: function fetchProduct(search) {
      var _this3 = this;
      this.loading = true;
      _product.productApi.findAll({
        limit: 50,
        page: 1,
        search: search
      }).then(function (res) {
        return _this3.products = res.data.products;
      }).finally(function () {
        return _this3.loading = false;
      });
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  required: true
})], ProductOrderForm.prototype, "form", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductOrderForm.prototype, "statusForm", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ProductOrderForm.prototype, "orderStatus", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("form.products", {
  deep: true
})], ProductOrderForm.prototype, "watchFormProducts", null);
ProductOrderForm = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    AddProductOrderModal: _AddProductOrderModal.default
  }
})], ProductOrderForm);
var _default = exports.default = ProductOrderForm;